<template>
  <div
    ref="target"
    :class="[{ 'z-50': isDropdownShown }, { 'inline-flex': isMinimalistic }]"
  >
    <button v-if="isButtonLike" @click="isDropdownShown = !isDropdownShown">
      <SvgIcon name="dots-three-vertical" />
    </button>
    <div
      v-else
      class="dropdown-select__selected flex max-w-[230px] cursor-pointer items-center justify-between text-[18px] text-[#4d4d4d] 2xl:max-w-[initial]"
      :class="{ 'bg-white-100': !isMinimalistic }"
      @click="isDropdownShown = !isDropdownShown"
    >
      <span class="flex min-w-0 items-baseline">
        <span class="truncate">{{ getCurrentSelected }}</span>
        <span
          v-if="currentItem?.counter"
          class="ml-1.5 hidden shrink-0 text-[14px] leading-none text-[#808080] md:inline"
          >{{ currentItem.counter }}</span
        >
      </span>
      <SvgIcon
        :name="isDropdownShown ? 'chevron-up' : 'chevron-down'"
        class="ml-2 size-4 min-w-[16px]"
      />
    </div>
    <div
      v-if="isDropdownShown"
      class="absolute inset-x-0 top-full flex w-full flex-col rounded-b-[12px] bg-white-100 shadow-drop-2"
    >
      <div
        class="z-[51] mt-[-10px] h-[31px] w-full bg-white-100 md:mt-[-20px] lg:mt-[-31px]"
      >
        <div
          class="relative top-full z-[51] h-px w-full bg-new-card--border px-9"
        ></div>
      </div>
      <div class="pb-9 pl-9">
        <div
          class="custom-scrollbar flex max-h-[390px] flex-col overflow-scroll pt-8 md:flex-wrap"
        >
          <!-- grid grid-cols-[repeat(auto-fit,minmax(213px,1fr))] -->
          <div
            v-for="(item, index) in list"
            :key="`select-item-${item.id}-${index}`"
            class="mb-2 mr-9 w-full max-w-[260px] rounded-lg p-1 text-[18px] leading-[23px]"
            :class="
              item.disabled
                ? 'cursor-default opacity-40'
                : 'cursor-pointer hover:bg-new-gray-lighter'
            "
            @click="!item.disabled && handleSelect(item.id)"
          >
            {{ item && item.label ? item.label : '' }}
            <span
              v-if="item.counter"
              class="text-[14px] leading-none text-[#808080]"
              >{{ item.counter }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  list: {
    type: Array,
    default: () => [],
  },

  initialSelectValue: {
    type: Number,
    default: 0,
  },

  isMinimalistic: {
    type: Boolean,
    default: false,
  },

  isButtonLike: {
    type: Boolean,
    default: false,
  },

  isOnChangeLocalVarsResetEnabled: {
    type: Boolean,
    default: false,
  },

  placeholder: {
    type: String,
    default: 'Выберите...',
  },

  // width: {
  //   type: Number,
  //   default: 0,
  // },
});

const emit = defineEmits(['on-select']);

const { isLessThanHorizontalPad } = useBreakpoint();

const currentSelectedId = ref(undefined);
const isDropdownShown = ref(false);
const target = ref(null);

const currentItem = computed(() => {
  const id =
    typeof currentSelectedId.value === 'undefined'
      ? props.initialSelectValue
      : currentSelectedId.value;

  return id ? props.list.find((el) => el.id === id) : undefined;
});

const getCurrentSelected = computed(() => {
  let res = currentItem.value ? currentItem.value.label : props.placeholder;

  const truncLength = isLessThanHorizontalPad.value ? 21 : 31;
  if (res.length > truncLength) {
    res = `${res.slice(0, truncLength)}...`;
  }
  return res;
});

const handleSelect = (id) => {
  isDropdownShown.value = false;
  currentSelectedId.value = id;

  emit('on-select', currentSelectedId.value);

  if (props.isOnChangeLocalVarsResetEnabled) {
    currentSelectedId.value = undefined;
  }
};

const closeDropdown = () => {
  isDropdownShown.value = false;
};

onClickOutside(target, () => {
  closeDropdown();
});
</script>

<style lang="scss"></style>
